<template>
  <ReferenceComponentParentList
    :searchList="result"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    @onClick="onTeamSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Teams
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div class="reference-team">
        <div class="reference-team__left">
          <Avatar
            :src="option.picture?.pictureUrl"
            size="md"
            type="teamsGroup"
          />
        </div>
        <div class="reference-team__right">
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-07"
          >
            {{ option.name }} ({{ option.size }})
          </BaseSubHeading>
        </div>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action, Getter } from "s-vuex-class"

import Avatar from "@/components/Avatar/index.vue"
import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { FilterTeam, Project, ServerResponse, Team } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions, Getters } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList,
  Avatar
}

@Options({
  name: "TeamList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Getter(Getters.GET_PROJECT) declare currentProject: Project

  @Action(Actions.SEARCH_TEAM) findTeams: (payload: FilterTeam) => Promise<ServerResponse<Team>>

  componentType = ReferenceType.TEAM
  waitTitle = "reference.search.team"
  result: Team[] = []
  isLast = true

  async mounted() {
    this.filter = FilterTeam.createDefault()
    this.filter.projectId = this.projectId
    this.filter.demo = this.currentProject?.demo ?? false
    this.searchAction = this.onSearchTeam
  }

  queryUpdated(q) {
    this.filter.page = 1
    this.filter.q = q.substring(1) ?? ""
    this.search()
  }

  onEnterHandler() {
    this.onTeamSelected(this.result[this.selectedIndex])
  }

  onTeamSelected(payload) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  async onSearchTeam() {
    const serverResponse = await this.findTeams(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
